import React from 'react';
import { Desktop, Mobile } from '../../../app-responsive';
import { CarouselItem, WideCarouselItem } from './content-types';
import CarouselDataWrapper from '../../../components/carousel/carousel-data-wrapper';

const EventCarousel = (props) => {
  const { contentToMap, cardsPerSlideDesktop, cardsPerSlideMobile, wideCarouselItems, mobile, desktop } = props;
  const RepeatableInjectedComponent = wideCarouselItems ? WideCarouselItem : CarouselItem;
  return (
    <React.Fragment>
      {desktop && <Desktop>
        <CarouselDataWrapper
          contentToMap={contentToMap}
          RepeatableInjectedComponent={RepeatableInjectedComponent}
          cardsPerSlide={cardsPerSlideDesktop}
          {...props}
        />
      </Desktop>}
      {mobile && <Mobile>
        <CarouselDataWrapper
          contentToMap={contentToMap}
          RepeatableInjectedComponent={RepeatableInjectedComponent}
          cardsPerSlide={cardsPerSlideMobile}
          {...props}
        />
      </Mobile>}
    </React.Fragment>
  );
};

export default EventCarousel;
